// store/UserProvider.js
import { createContext } from "react";

export const UserContext = createContext(null);
export const UserChangeContext = createContext(null);
export const CombineContext = createContext(null);
export const UiContext = createContext(null);
export const AgencyContext = createContext(null);
